if ($('#footer').length) {
  $('#signature').html('Vytvořil Shoptet | Nakódoval Milan Hrnčál | Design by Klára Drážná')
}